import type { VoidFunctionComponent } from 'react';

const BinaryAnalysisContainer: VoidFunctionComponent = () => {
  return <div>Binary Analysis</div>;
};

export default BinaryAnalysisContainer;
